import styled from 'styled-components';

const StyledCheckbox = styled.button`
  display: flex;
  cursor: pointer;
  height: 16px;
  min-width: 18px;
  border-radius: 2px;
  border: none;
  background: none;
  justify-content: center;
  align-items: center;

  svg path {
    fill: ${({ theme }) => theme.colors.mainColor};
  }

  :disabled {
    svg path {
      fill: ${({ theme }) => theme.colors.gray400};
    }
    cursor: not-allowed; 
  }
`;

const StyledCheckboxLabel = styled.label`
  ${({ theme }) => theme.typograph.paragraphRegular}
  padding-top: 2px;
  margin-left: 12px;
`;

export {
  StyledCheckbox,
  StyledCheckboxLabel,
};
